var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgContactInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 34C14 29.5817 17.5817 26 22 26C26.4183 26 30 29.5817 30 34H14ZM22 25C18.685 25 16 22.315 16 19C16 15.685 18.685 13 22 13C25.315 13 28 15.685 28 19C28 22.315 25.315 25 22 25ZM32 29H36V31H32V29ZM29 24H36V26H29V24ZM31 19H36V21H31V19Z",
    fill: "#0F4A43"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContactInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contact-info.1c3d8310.svg";
export { ForwardRef as ReactComponent };